import accordionGroup from "./accordionGroup.component";

const accordionGroupModule = angular
  .module("app.components.accordionGroup", [])
  .component("accordionGroup", accordionGroup);

export default accordionGroupModule;



// WEBPACK FOOTER //
// ./src/components/accordionGroup/accordionGroup.module.js